import { Descriptions, Space } from 'antd'
import { fromUnixTime } from 'date-fns'
import { Link } from 'react-router-dom'

import { FormattedDate } from '@/components/common/FormattedDate'
import { MonoId } from '@/components/common/MonoId'
import { StatusTag } from '@/components/common/StatusTag'
import { UserEmailLink } from '@/components/common/UserEmailLink'

import { providerName } from '../format'
import type { GpuInstance } from '../hooks/useGpuOperations'
import { DATE_FMT, InstanceStatus, ReservationTags } from './columns'

export const date = (value: string | null | undefined) => (
  <FormattedDate date={value} fmt={DATE_FMT} />
)

export function InstanceDetails({ instance }: { instance: GpuInstance }) {
  const { lease, reservation } = instance
  return (
    <Descriptions bordered size="small" column={{ xs: 1, md: 2 }}>
      <Descriptions.Item label="Status">
        <InstanceStatus status={instance.status} />
      </Descriptions.Item>
      <Descriptions.Item label="User">
        <UserEmailLink userId={instance.user_id} />
      </Descriptions.Item>
      <Descriptions.Item label="Provider">
        <Link to={`/gpu/providers/${instance.provider}`}>
          {providerName(instance.provider)}
        </Link>
      </Descriptions.Item>
      <Descriptions.Item label="Workload">
        {instance.workload}
      </Descriptions.Item>
      <Descriptions.Item label="Created">
        {date(instance.created_at)}
      </Descriptions.Item>
      <Descriptions.Item label="Activated / ended">
        {date(instance.activated_at)} / {date(instance.ended_at)}
      </Descriptions.Item>
      <Descriptions.Item label="Lease">
        {lease ? (
          <Space size={4} wrap>
            <StatusTag status={lease.status} />
            <MonoId id={lease.provider_id} />
          </Space>
        ) : (
          '—'
        )}
      </Descriptions.Item>
      <Descriptions.Item label="Unready since">
        {lease?.unready_since
          ? date(fromUnixTime(lease.unready_since).toISOString())
          : '—'}
      </Descriptions.Item>
      <Descriptions.Item label="vodopad resource">
        <MonoId id={reservation?.resource_id} />
      </Descriptions.Item>
      <Descriptions.Item label="Reservation">
        <ReservationTags reservation={reservation} />
      </Descriptions.Item>
      <Descriptions.Item label="Report held since">
        {date(reservation?.held_at)}
      </Descriptions.Item>
      <Descriptions.Item label="vodopad closure">
        {reservation?.vodopad_closure ?? '—'}
      </Descriptions.Item>
    </Descriptions>
  )
}
